import { gql } from "apollo-boost";

export const CREATE_ATTRIBUTEVALUE = gql`
mutation CreateAttributeValue($data: AttributeValueInput!) {
  createAttributeValue(data: $data) {
    value
    shop {
      id
      name
    }
    attribute {
      name
    }
  }
}
`

export const UPDATE_ATTRIBUTEVALUE = gql`
mutation UpdateAttributeValue($data: AttributeValueInput, $where: AttributeValueWhereInputOne!) {
  updateAttributeValue(data: $data, where: $where) {
    id
  }
}
`

export const DELETE_ATTRIBUTEVALUE = gql`
mutation DeleteAttributeValue($where: AttributeValueWhereInputOne!) {
  deleteAttributeValue(where: $where) {
    id
  }
}
`
